import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";


import Overview from "./Overview";
import CNC from "./CNC";
import Mill from "./Mill";
import PlateBender from "./PlateBender";
import PlasmaCutter from "./PlasmaCutter"
import WaterjetCutter from "./WaterjetCutter"
import Lathe from "./Lathe"


const ChangeComponents = {
    overview: Overview,
    cnc: CNC,
    mill: Mill,
    platebender: PlateBender,
    plasmacutter: PlasmaCutter,
    waterjetcutter: WaterjetCutter,
    lathe: Lathe,


  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }